export default {
  ticker: 'Ticker',
  issuerTicker: 'Issuer',
  derivativeTypeName: 'Type',
  conversionRate: 'Conversion Rate',
  issuePrice: 'Issue Price',
  referencePrice: 'Ref',
  matchPrice: 'Price',
  priceChange: 'Change',
  percentPriceChange: '%1D Change',
  totalMatchVolume: 'Volume',
  totalMatchValue: 'Value',
  best1Bid: 'Best Bid',
  best1Offer: 'Best Ask',
  dayRange: 'Day Range',
  ceilingPrice: 'Ceiling',
  floorPrice: 'Floor',
  openPrice: 'Open',
  highestPrice: 'High',
  lowestPrice: 'Low',
  basis: 'Basis',
  performance: 'Performance',
  foreignBuyVolumeTotal: 'Fr. Buy Vol',
  foreignSellVolumeTotal: 'Fr. Sell Vol',
  FR_BUY_VAL: 'Fr. Buy Val',
  FR_SELL_VAL: 'Fr. Sell Val',
  dealPrice: 'Put Through Price',
  totalDealVolume: 'Put Through Volume',
  totalDealValue: 'Put Through Value',
  SYMBOL_TICKER: 'Symbol Ticker',
  exercisePrice: 'Exercise Price',
  averagePrice1Week: 'Avg Price 5D',
  BREAK_EVEN_PRICE: 'Breakeven Price',
  orgMatchPrice: 'Current Price',
  PREMIUM: '% Premium',
  maturityDate: 'Expire Date',
  lastTradingDate: 'Last Trading Date',
};
